import { PersonDTO } from "./PersonDTO";
import { User } from "model/user.model";
import { mapStringToLanguage } from "config/translations/I18n";

/** ---- API DTO ---- */
export interface UserDTO {
  readonly id: number;
  readonly active: boolean;
  readonly username: string;
  readonly corilusPersonId: string;
  readonly person: PersonDTO;
  readonly triagram: string;
}

/** ---- API MAPPING ---- */
export const mapToUserModel = (userDTO: UserDTO): User => {
  const { person } = userDTO;
  const user = new User();
  user.id = userDTO.id;
  user.username = userDTO.username;
  user.corilusPersonId = userDTO.corilusPersonId;
  if (person) {
    user.inss = person.inss;
    user.nihii = person.nihii;
    user.firstName = person.firstName;
    user.lastName = person.lastName;
    user.displayName = person.displayName
      ? person.displayName
      : person.lastName + " " + person.firstName;
    user.language = mapStringToLanguage(person.language) ?? "nl";
  }
  user.trigram = userDTO.triagram;
  return user;
};
